export default __webpack_public_path__ + "72f0883064e052e070dc8f25888e96f3.jpg";